import {createContext, useContext} from 'react';

const TimeContext = createContext();

const TimeProvider = ({children, value}) => {
  return <TimeContext.Provider value={value}>{children}</TimeContext.Provider>;
};

const useTime = () => {
  const context = useContext(TimeContext);
  if (context === undefined) {
    throw new Error('useTime must be used within a TimeProvider');
  }
  return context;
};

export {useTime, TimeProvider};
